import { Cell } from '@table-library/react-table-library/table';
import Sparkline from '../../../components/Sparklines';
import numeral from 'numeral';
import IgnoreButton from './ignoreButton';
import { collectCell } from '../../../helpers/showPriorData';

export const COLUMNS = ({ endpoint_url, csrf_token, deleteIgnoredItem, t }) => [
    {
        label: t('search.list_keywords.keyword'),
        key: 'keyword',
        data: 'keyword',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/keywords/keyword?keyword=${encodeURIComponent(data)}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.list_keywords.first_seen_last_seen'),
        key: 'seen',
        data: 'seen',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return `${item.firstSeen.value} -> ${item.firstSeen.value}`;

            return (
                <div>
                    <strong>{item.firstSeen.value}</strong>
                    <div className="delta-number">{item.lastSeen.value}</div>
                </div>
            );
        },
    },
    {
        label: t('search.list_keywords.max_clicks'),
        key: 'maxClicks',
        data: 'maxClicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.list_keywords.clicks'),
        key: 'avgClicks',
        data: 'avgClicks',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return collectCell(data, item.clicksL);
        },
    },
    {
        label: t('search.list_keywords.trend'),
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return <Sparkline dataL={item.clicksL} keyName={t('search.list_keywords.clicks')} />;
        },
    },
    {
        label: t('search.list_keywords.urls'),
        key: 'avgURLs',
        data: 'avgURLs',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return collectCell(data, item.urlsL);
        },
    },
    {
        label: t('search.list_keywords.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return collectCell(data, item.positionL);
        },
    },
    {
        label: t('search.list_keywords.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return collectCell(data, item.impressionsL);
        },
    },
    {
        label: t('search.list_keywords.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.avgClicks / item.impressions;
            if (csvDownload) return ctrValue;

            return collectCell(ctrValue, item.ctrL, '0.00%');
        },
    },
    {
        label: t('search.list_keywords.actions'),
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return null;

            return (
                <IgnoreButton
                    keyword={item.keyword}
                    endpoint_url={endpoint_url}
                    csrf_token={csrf_token}
                    deleteIgnoredItem={deleteIgnoredItem}
                />
            );
        },
    },
];
